"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JUSTIFY_MAP = {
    between: 'space-between',
    center: 'center',
    end: 'flex-end',
    start: 'flex-start'
};
//# sourceMappingURL=justify.types.js.map